/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subject, Subscription, of, takeUntil } from 'rxjs';
import {
  ROOT_PATH_FACADE_TOKEN,
  IRootPathSelectorFacade,
} from '../../../../../data-access/src/lib/domain/facades-models/root-path-selector-facade-interface';

@Component({
  selector: 'sysque-root-path-selector',
  templateUrl: './root-path-selector.component.html',
  styleUrls: ['./root-path-selector.component.scss'],
  standalone: false
})
export class RootPathSelectorComponent implements OnInit, OnDestroy {
  @Input() manageMode: boolean;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() rootPathChanged: EventEmitter<any> = new EventEmitter<any>();
  rootPathValue = '';
  isRootPathValueSubscription: Subscription;
  public rootPath$: Observable<string>;
  private readonly closed$ = new Subject<void>();

  constructor(
    @Inject(ROOT_PATH_FACADE_TOKEN) private rootPathFacade: IRootPathSelectorFacade,
    public cdr: ChangeDetectorRef
  ) {}

  ngOnDestroy(): void {
    if (this.isRootPathValueSubscription) {
      this.isRootPathValueSubscription.unsubscribe();
    }
    window.removeEventListener('storage', this.handleStorageEvent.bind(this));
    this.closed$.next();
    this.closed$.complete();
  }

  ngOnInit(): void {
    this.rootPath$ = this.rootPathFacade.initializeRootPath();
    window.addEventListener('storage', this.handleStorageEvent.bind(this));
  }

  handleStorageEvent(event: StorageEvent): void {
    if (event.key === 'rootPath') {
      this.rootPath$ = of(event.newValue);
    }
  }

  getRootPath() {
    this.rootPath$ = of('');
    this.rootPathFacade
      .selectRootPath()
      .pipe(takeUntil(this.closed$))
      .subscribe((response) => {
        if (response != null) {
          this.rootPathValue = response;
          this.rootPath$ = of(this.rootPathValue);
          this.rootPathFacade.setRootPath(this.rootPathValue);
          this.rootPathChanged.emit(true);
          this.cdr.detectChanges();
        }
      });
  }

  onValueChanged($event: any) {
    this.valueChanged.emit($event);
  }
}
